import { getCutIndex } from './getCutIndex';

export const needExpand = (text: string) => {
  return getCutIndex(text) < text.length;
};
